var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createDocument } from "@/06-shared/api";
import { useNotifyError } from "@/06-shared/lib/useNotifyError";
import { PopupButton, PopupInput, PopupWindow } from "@/06-shared/ui/popups";
import { useState } from "react";
export const CreateDocument = ({ isOpen, parentId = null, onSuccess, onClose }) => {
    const [documnetName, setDocumentName] = useState("");
    const showError = useNotifyError();
    const onCreateDocument = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const documentId = yield createDocument({
                name: documnetName,
                type: "document",
                parentId
            });
            onSuccess(documentId);
        }
        catch (error) {
            showError(error);
        }
        finally {
            onClose();
        }
    });
    return (isOpen ? (_jsxs(PopupWindow, Object.assign({ name: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442", onClose: () => { onClose(); } }, { children: [_jsx(PopupInput, { name: "\u0418\u043C\u044F \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430", setInput: (data) => setDocumentName(data), onEnter: onCreateDocument, autoFocus: true }), _jsx(PopupButton, { name: "[Ok]", onClick: () => onCreateDocument() })] }))) : null);
};
